<template>
  <b-modal
    id="modal-special-offer"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
      <div class="headline" :class="$store.state.locale"></div>
    </template>

    <template slot="default">
      <div
        v-if="rewards[0]"
        class="offer-reward-container1 d-flex flex-column align-items-center justify-content-between"
      >
        <div class="icon-gold" :style="iconGoldStyle"></div>
        <div
          v-if="rewards[0].gold > 0"
          class="amount-gold golden-gradient-text"
        >
          {{ formatNumber(rewards[0].gold) }}
        </div>
        <div
          v-if="rewards[0].crown > 0"
          class="w-100 d-inline-flex align-items-center justify-content-center"
        >
          <div class="amount-crown golden-gradient-text">
            {{ formatNumber(rewards[0].crown) }} x
          </div>
          <BaseAsset asset="secondary" class="icon-crown ms-1"></BaseAsset>
        </div>

        <div
          class="w-100 package-bonus-icons d-inline-flex align-items-center justify-content-around"
        >
          <div v-if="rewards[0].card > 0" class="package-item">
            <BaseAsset asset="cards" size="big" />
            <div class="text">{{ formatNumber(rewards[0].card) }} x</div>
          </div>

          <div v-if="rewards[0].loyalty > 0" class="package-item">
            <BaseAsset asset="loyalty" size="big" />
            <div class="text">{{ formatNumber(rewards[0].loyalty) }} x</div>
          </div>

          <div v-if="rewards[0].elixir > 0" class="package-item">
            <BaseAsset asset="tertiary" size="big" />
            <div class="text">{{ formatNumber(rewards[0].elixir) }} x</div>
          </div>

          <div v-if="rewards[0].expbooster > 0" class="package-item">
            <BaseAsset asset="booster" size="big" />
            <div class="text">
              {{ Math.round(rewards[0].expbooster / 60) }} Min.
            </div>
          </div>
        </div>
      </div>
      <div class="submit-button pt-3" @click="buyItem(0, 'Offer', 'Special')">
        <p class="bold text-uppercase text-white m-0">
          {{ $t("shop.offers.buy_button", { 0: "" }) }}
        </p>

        <div class="big bold text-white m-0 position-relative">
          {{ formatPrice(price[0]) }} €

          <div
            v-if="oldPricesSpecial && oldPricesSpecial[0]"
            class="offer-old-price"
          >
            {{ formatPrice(oldPricesSpecial[0]) }} €
            <div class="offer-red-line to-center-abs"></div>
          </div>
          <div
            v-if="moreContentSpecial && moreContentSpecial[0]"
            class="big-badge-more-percent smaller"
          >
            <span class="big">{{ moreContentSpecial[0] }}</span>
            {{ $t("shop.offers.more_contents2") }}
          </div>
        </div>
      </div>

      <div class="badge-big">
        <div class="badge-text">
          <i18next :translation="$t('shop.offers.badge4a')"
            ><template #0
              ><div class="big">
                {{ validDuration }}
              </div></template
            ></i18next
          >
        </div>
        <div
          class="countdown-box d-flex flex-column align-items-center justify-content-around position-absolute w-100 text-uppercase medium"
        >
          <span>{{ $t("shop.offers.countdown.time_remaining") }}</span>
          <div
            v-if="$store.getters['shop/getSpecialOfferTime'] > 360000"
            class="w-75 d-inline-flex align-items-center justify-content-around"
          ></div>
          <CountdownDigital
            :time="$store.getters['shop/getSpecialOfferTime']"
            :with-time-diff="true"
          ></CountdownDigital>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import CountdownDigital from "@/components/base/countdown-digital.vue";
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "../../base/base-asset.vue";
export default {
  name: "ModalSpecialOffer",
  components: { CountdownDigital, BaseAsset },
  mixins: [offerModalContent],
  data() {
    return {
      isSpecialOffer: true,
      isPipelineOffer: true,
    };
  },

  computed: {
    iconGoldStyle() {
      return {
        background: `url(${this.$whitelabel.currencies.primary.triple}) center/100% 100% no-repeat`,
      };
    },
    validDuration() {
      const offer = this.$store.state.shop.specialOffer;
      if (!offer || !offer.configuration) {
        return;
      }
      const conf = JSON.parse(offer.configuration);
      const numberOfDays = Math.max(Math.ceil(conf.temporal.amount / 24), 1);
      let string = this.$t("time.day.other");
      if (numberOfDays === 1) {
        string = this.$t("time.day.one");
      }
      return numberOfDays + " " + string;
    },

    oldPricesSpecial() {
      const offer = this.$store.state.shop.specialOffer;
      if (!offer || !offer.configuration) {
        return;
      }
      const conf = JSON.parse(offer.configuration);
      return conf.old_prices;
    },

    moreContentSpecial() {
      const offer = this.$store.state.shop.specialOffer;
      if (!offer || !offer.configuration) {
        return;
      }
      const conf = JSON.parse(offer.configuration);
      return conf.more_content;
    },
  },
  created() {
    this.$root.$on("show-special-offer", () =>
      this.$bvModal.show("modal-special-offer")
    );
  },
  mounted: function () {
    if (this.$store.state.shop.autoShowSpecialOffer) {
      this.$bvModal.show("modal-special-offer");
      this.deactivateAutoShow();
    } else {
      this.$store.commit("popups/setNextPipelineQueueStep");
    }
  },
  methods: {
    deactivateAutoShow() {
      if (!this.$store.state.shop.autoShowSpecialOffer) {
        return;
      }
      this.$store.commit("shop/setAutoShowSpecialOffer", false);
    },
  },
};
</script>
<style lang="scss">
$modal-width: 1012px;
$modal-height: 776px;

#modal-special-offer {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 830px) {
      transform: scale(0.8);
      top: -100px;
      margin-bottom: -20%;
    }
  }

  .modal-content {
    width: $modal-width;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("~@/assets/img/shop/offers/special-1.png");
    background-color: transparent;
  }

  .close-button {
    top: 50px;
    right: -30px;
  }
}
</style>

<style scoped lang="scss">
#modal-special-offer {
  .headline {
    height: 250px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    &.en {
      background-image: url(~@/assets/img/shop/offers/specialoffer-hl-en.png);
      top: 10px;
      left: 350px;
      width: 350px;
    }

    &.de {
      background-image: url(~@/assets/img/shop/offers/specialoffer-hl-de.png);
      top: 10px;
      left: 280px;
      width: 470px;
    }
  }

  .offer-reward-container1 {
    top: 165px;
    left: 340px;
    width: 398px;
    position: absolute;

    .icon-gold {
      width: 150px;
      height: 94px;
    }

    .amount-gold {
      font-size: 40px;
      font-family: Ubuntu-Bold;
      position: relative;
      display: inline-flex;
      text-align: center;
      margin-top: 5px;
      line-height: 1;
      filter: drop-shadow(0 0 12px $drop-shadow-dark)
        drop-shadow(0 0 6px $btn-drop-shadow-blue-modern);
    }

    .amount-crown {
      font-size: 38px;
      font-family: Ubuntu-Bold;
      filter: drop-shadow(0 0 15px $drop-shadow-dark)
        drop-shadow(0 0 7px $btn-drop-shadow-blue-modern);
    }
    .icon-crown {
      width: 70px;
      height: 70px;
    }

    .package-bonus-icons {
      margin-top: 24px;
      padding: 0 20px;

      .package-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;

        .text {
          color: $text-accent;
          font-family: Ubuntu-Medium;
          font-size: 24px;
        }
      }
    }
  }
  .submit-button {
    width: 236px;
    height: 95px;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
    line-height: 1;
    left: 412px;
    bottom: 133px;
    position: absolute;
    p {
      text-shadow: 0 0 12px $text-shadow-dark-green,
        0 0 4px $text-shadow-dark-green;
    }

    .big {
      font-size: 48px;
    }

    .offer-old-price {
      top: -50px;
      right: -90px;
    }

    .big-badge-more-percent {
      top: -420px;
      right: -180px;
    }
  }

  .badge-big {
    width: 253px;
    height: 333px;
    background: url(~@/assets/img/shop/offers/bg-counter-badge.svg) center/100%
      100% no-repeat;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 45px;
    top: 217px;
    text-shadow: 0 1px 6px $drop-shadow-dark, 0 1px 6px $drop-shadow-dark,
      0 1px 6px $drop-shadow-dark;
    .badge-text {
      color: white;
      text-transform: uppercase;
      font-family: Ubuntu-Bold;
      text-align: center;
      font-size: 31.8px;
      transform: rotate(-10deg);
      position: absolute;
      left: 71px;
      top: 50px;
      line-height: 1;
      width: 100px;
      .big {
        font-family: Ubuntu-Bold;
        font-size: 48px;
      }
    }
    .countdown-box {
      height: 80px;
      bottom: 15px;
      font-size: 18px;
      line-height: 1.2;
      .countdown-digital {
        font-size: 38px;
      }
    }
  }
}
</style>
